import { render } from "./UserProfilePage.vue?vue&type=template&id=125f6d61"
import script from "./UserProfilePage.vue?vue&type=script&lang=js"
export * from "./UserProfilePage.vue?vue&type=script&lang=js"
script.render = render

export default script